import { Component, OnInit } from '@angular/core';

import { ClientService } from '../../../services/client/client.service';

import { default as swal } from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { Bill } from '../../../../client/billing/subscription/store/bill';
import { Observable } from 'rxjs';
declare var Stripe: any;



export class BillingComponent implements OnInit {

	public sendingData: boolean = false;
	public dataLoaded: boolean = false;
	public allowToSign: boolean = false;

	public guestName: string = '';
	public guestEmail: string = '';
	public guestTitle: string = '';
	public guestPurchaseOrderNumber: string = '';
	public guestAcceptTermsAndConditions: boolean = false;

	public latestBillingState: any;
	public stripeCardElement: any;
	public stripeValidationError = '';

	public packageTotalProductsPrice: number;
	public packageTotalPrice: number;
	public packagePriceCurrency: string;

	private stripe: any;
	private isPaymentMethodCard: boolean;

	constructor(
		private clientService: ClientService,
		private activatedRoute: ActivatedRoute) { }

	/* Lifecycle events */
	public ngOnInit(): void {
		this.getMandatoryData();
	}

	public onFormSubmit(): void {
		if (!this.guestName || !this.guestEmail || !this.guestAcceptTermsAndConditions || !this.guestTitle || this.stripeValidationError) {
			return;
		}
		this.sendingData = true;
		if (this.isPaymentMethodCard) {
			this.stripe.createToken(this.stripeCardElement).then((result) => {
				if (result.error) {
					this.sendingData = false;
					this.stripeValidationError = result.error.message;
				} else {
					this.submitBillingData({stripe_source_id: result.token.id}).subscribe(
						(subscription) => {
							let payment_intent = subscription.latest_invoice.payment_intent;
							switch (payment_intent.status) {
								case 'requires_action': {
									let paymentIntentSecret = payment_intent.client_secret;
									this.stripe.handleCardPayment(paymentIntentSecret).then((paymentResult) => {
										if (paymentResult.error) {
											this.sendingData = false;
											this.stripeValidationError = paymentResult.error.message;
										} else {
											this.showSuccessModal();
										}
									});
									break;
								}
								case 'succeeded': {
									this.showSuccessModal();
									break;
								}
								default: {
									this.sendingData = false;
									this.stripeValidationError = 'Something went wrong processing the payment, please try again later or contact us at contact@hackajob.co!';
									break;
								}
							}
						},
						(error) => {
							this.sendingData = false;
							this.stripeValidationError = error.message;
						}
					);
				}
			});
		} else {
			this.submitBillingData().subscribe(
				() => {
					this.showSuccessModal();
				},
				() => {
					this.sendingData = false;
					this.stripeValidationError = 'Something went wrong processing the payment, please try again later or contact us at contact@hackajob.co!';
				}
			);
		}
	}

	private showSuccessModal() {
		swal({
			title: 'Success',
			text: 'Thanks for signing the terms and conditions!',
			type: 'success',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		}).then(
			() => {
				window.location.assign(process.env.LANDING_PAGES_URL);
			},
		);
	}

	private submitBillingData(extraData?: any): Observable<any> {
		let data = {
			name: this.guestName,
			email: this.guestEmail,
			title: this.guestTitle
		};

		if (this.latestBillingState.type !== 'package') {
			data['purchase_order_number'] = this.guestPurchaseOrderNumber;
		}

		if (extraData) {
			data = {...data, ...extraData};
		}

		return this.clientService.postBillingSign(data);
	}

	private getMandatoryData(): void {
		this.clientService.getBillingLatest().subscribe(
			( latestBilling) => {
				this.dataLoaded = true;
				this.latestBillingState = latestBilling;

				if (this.latestBillingState.type === 'package' && this.latestBillingState.status !== 'current') {
					window.location.assign(process.env.LANDING_PAGES_URL);

					return;
				}

				if (latestBilling['document'] && latestBilling['document']['pdf_file_custom']) {
					this.activatedRoute.parent.params.subscribe((params: any) => {
						let postData = {};
						postData['token'] = params['token'];

						this.clientService.createClientToken(postData).subscribe(
							(clientToken) => {
								window.location.href = process.env.LEGACY_PUBLIC_URL + '/sso/client/' + clientToken + '?redirect_to=' + process.env.APP_URL + '/user';
							}
						);
					});

					return;
				}

				if (latestBilling['terms_and_conditions_signed'] && (latestBilling['payment_status'] === 'succeeded' || latestBilling['payment_method'] === 'invoice')) {
					this.allowToSign = false;
					swal({
						title: '',
						text: 'Thank you, but someone already signed the terms and conditions for your company!',
						type: 'success',
						showCancelButton: false,
						confirmButtonColor: '#008fb3',
						confirmButtonText: 'Ok',
						allowOutsideClick: false,
						allowEscapeKey: false
					}).then(
						() => {
							window.location.assign(process.env.LANDING_PAGES_URL);
						}
					);
				} else {
					if (this.latestBillingState.package) {
						this.packageTotalProductsPrice = 0;
						this.packageTotalPrice = this.latestBillingState.package.total_price;
						if (this.latestBillingState.package.products && this.latestBillingState.package.products.length) {
							this.latestBillingState = this.orderProducts(this.latestBillingState);
							this.latestBillingState.package.products.forEach((product) => {
								if (product.plan && product.plan.price) {
									this.packageTotalProductsPrice += product.plan.price;
								}
								if (product.plan && product.plan.currency && !this.packagePriceCurrency) {
									this.packagePriceCurrency = product.plan.currency;
								}
							});
						}
						if (this.latestBillingState.package.payment_method === 'card') {
							this.isPaymentMethodCard = true;
							setTimeout(() => {
								this.initStripeCard();
							});
						}
					}
					this.allowToSign = true;
				}
			},
			() => {
				this.dataLoaded = true;
				this.allowToSign = true;
			}
		);
	}

	private initStripeCard(): void {
		this.stripe = Stripe(process.env.STRIPE_PUBLIC_KEY);

		let elements = this.stripe.elements();
		let style = {
			base: {
				'iconColor': '#444444',
				'color': '#31325f',
				'fontWeight': 400,
				'fontFamily':
					'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
				'fontSmoothing': 'antialiased',
				'fontSize': '14px',
				'::placeholder': {
					color: '#aab7c4',
				},
				':-webkit-autofill': {
					color: '#666ee8',
				}
			}
		};

		this.stripeCardElement = elements.create('card', {
			hidePostalCode: true,
			style
		});
		this.stripeCardElement.mount('#credit-card-element');
		this.stripeCardElement.addEventListener('change', ({error}) => {
			this.stripeValidationError = error ? error.message : '';
		});
	}

	private orderProducts(bill: Bill): Bill {
		bill.package.products.sort((a, b) => {
			if (a.identifier === 'interview-requests') {
				return -1;
			} else if (b.identifier === 'interview-requests') {
				return 1;
			}
			return 0;
		});
		return bill;
	}
static ctorParameters() { return [ { type: ClientService }, { type: ActivatedRoute } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/components/client/billing/billing.component.ts